import { createContext } from 'react';

export type ToastType = 'info' | 'success' | 'warning' | 'danger';

export interface ToastOptions {
  message: string;
  type?: ToastType;
  duration?: number;
  persistent?: boolean;
};

export interface ToastContextData {
  showToast: (options: ToastOptions) => void;
  dismissToast: () => void;
};

export const ToastContext = createContext<ToastContextData | null>(null);
